export function normalizeTzParam(raw) {
  if (!raw || typeof raw !== 'string') return null;
  let s = raw.trim();
  if (raw.startsWith(' ')) s = '+' + raw.trim();
  s = s.replace(/^UTC/i, '').trim();
  if (s.startsWith(' ')) s = '+' + s.trim();
  if (s === '' || s === '0' || s === '+0' || s === '-0') return '+00:00';
  const m = s.match(/^([+-]?)(\d{1,2})(?::?(\d{2}))?$/);
  if (!m) return null;
  const sign = m[1] === '-' ? '-' : '+';
  const h = String(parseInt(m[2], 10)).padStart(2, '0');
  const min = String(m[3] ? parseInt(m[3], 10) : 0).padStart(2, '0');
  return `${sign}${h}:${min}`;
}

export function offsetMinutes(offset = '+00:00') {
  let str = String(offset || '').trim();
  if (str.startsWith(' ')) str = '+' + str.trim();
  const match = str.replace(/^UTC/i, '').match(/^([+-]?)(\d{1,2}):(\d{2})$/);
  if (!match) {
    const normalized = normalizeTzParam(offset);
    if (normalized && normalized !== offset) return offsetMinutes(normalized);
    return 0;
  }
  return (match[1] === '-' ? -1 : 1) * (Number(match[2]) * 60 + Number(match[3]));
}

export function normalizeOffset(offset) {
  const minutes = offsetMinutes(offset);
  return (minutes < 0 ? '-' : '+') + String(Math.floor(Math.abs(minutes) / 60)).padStart(2, '0') + ':' + String(Math.abs(minutes) % 60).padStart(2, '0');
}

export function offsetDate(date, offset) { return new Date(new Date(date).getTime() + offsetMinutes(offset) * 60000); }
